<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="486px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    :destroy-on-close="true"
    @ok="formHandle"
    @cancel="cancelHandle"
  >
    <div class="source-tree-box">
      <!-- <div class="tree-define">
        <a-checkbox
          v-if="itemData.fieldconfig"
          :default-checked="!!itemData.fieldconfig.enableinput"
          @change="enableinput"
        >
          {{ $t('message["1220"]') }}
        </a-checkbox>
      </div> -->
      <div class="tree-container scroll_bar_beautify_ff">
        <tree-item
          v-if="itemData.options && itemData.options.length"
          :datas="itemData"
        />
      </div>
      <add-tree-form
        :datas="itemData.options"
        @addTree="addTree"
      />
    </div>
  </a-modal>
</template>
<script>
import TreeItem from './TreeItem'
import AddTreeForm from './AddTreeForm'
import { mapState, mapMutations } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  components: {
    TreeItem,
    AddTreeForm
  },
  props: {
    itemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false,
      cloneData: {}
    }
  },
  computed: {
    ...mapState('config/collect', ['treeDatas', 'decorators']),
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["926"]')
    },
    modalTit () {
      // 设置接待方式
      return this.$t('message[1761]')
    }
  },
  watch: {
    isLimitDialogShow (val) {
      if (val) {
        this.cloneData = cloneDeep(this.itemData)
      }
    }
  },

  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapMutations('config/collect', ['setTreeData']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.handleData(this.itemData.options)
      this.$emit('confirm', this.itemData.options)
      this.isLimitDialogShow = false
    },
    async handleSearch (val) {
      const chain = await this.getAdminId()
      chain.params({ cid: this.cId, keywords: val })
        .fetch()
    },
    handleData (arr) {
      arr.forEach((item, i) => {
        if (item.children && item.children.length) {
          this.handleData(item.children)
        }
        item.name = item.title.title
        if (item.name === '') {
          arr.splice(i, 1)
        }
      })
    },
    addTree (title) {
      this.itemData.options.push({
        name: title,
        _id: (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + (new Date()).getTime(),
        children: [],
        scopedSlots: { title: 'key' },
        level: 1
      })
      this.setTreeData(this.itemData.options)
    },
    /* enableinput (e) {
      const val = e.target.checked ? 1 : 0
      this.$set(this.itemData.fieldconfig, 'enableinput', val)
    }, */
    cancelHandle () {
      this.isLimitDialogShow = false
      // this.$set(this.itemData.fieldconfig, 'enableinput', this.cloneData.fieldconfig.enableinput)
      this.$set(this.itemData, 'options', this.cloneData.options)
      this.$emit('confirm', this.itemData.options)
    }
  }
}
</script>

<style lang="scss" scoped>
.source-tree-box::v-deep {
  .tree-container {
    max-height: 300px;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .ant-tree-switcher-icon {
    font-size: 16px !important;
    color: #d6d6d6;
  }
}
</style>
